import { useEffect, useState } from "react";
import AvatarSVG from "./AvatarSVG";

// Reusable circular avatar. Priority: an uploaded photo (`src`) always wins
// when present and loads; otherwise a user's custom PartyBuddy avatar
// (`avatarConfig`) is rendered; if neither is set, falls back to the
// existing 😊 badge — no caller needs its own broken-image handling.
function Avatar({ src, avatarConfig, size = 40, alt = "", className = "" }) {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [src]);

  const dimension = typeof size === "number" ? `${size}px` : size;
  const fontSize = typeof size === "number" ? `${size * 0.5}px` : undefined;

  if ((!src || broken) && avatarConfig) {
    return <AvatarSVG config={avatarConfig} size={size} className={className} />;
  }

  if (!src || broken) {
    return (
      <div
        style={{ width: dimension, height: dimension, fontSize }}
        className={`flex shrink-0 items-center justify-center rounded-full border border-slate-700 bg-slate-700/80 text-slate-200 ${className}`}
      >
        😊
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setBroken(true)}
      style={{ width: dimension, height: dimension }}
      className={`shrink-0 rounded-full border border-slate-700 object-cover bg-slate-800 ${className}`}
    />
  );
}

export default Avatar;
